import React from "react";
import ReactDOM from "react-dom";
// WORDPRESS components
import { withNotices } from "@wordpress/components";
import * as wpUrl from "@wordpress/url";
// THIRD PARTY modules
import "normalize.css";
import "../../node_modules/@wordpress/components/build-style/style.css";

// LOCAL components
import Dashboard from "./Dashboard";

// lodash noConflict
import _ from 'lodash'; _.noConflict();

// CONSTANTS
const queryArgs = wpUrl.getQueryArgs(window.location.href);
let updatedWidgetMeta = {};

const DashboardWithNotices = withNotices(({ noticeOperations, noticeUI }) => {
  const notify = ({ content, status }) => noticeOperations.createNotice({ content, status });
  return (
    <div>
      {noticeUI}
      <Dashboard
        notify={notify}
        widgetMeta={updatedWidgetMeta}
        step={queryArgs.step}
      />
    </div>
  );
});

async function mountComponent() {
  updatedWidgetMeta = await window.Widgetic.api('widgets/' + CONFIG.widgetId);
  global[CONFIG.widgetId] = {};
  global[CONFIG.widgetId].blockSlug = updatedWidgetMeta.slug;
  global[CONFIG.widgetId].blockPageStr = updatedWidgetMeta.name.toLowerCase().replace(' ', '_');
  // console.log("Dashboard index blockSlug:", global[CONFIG.widgetId].blockSlug);
  const rootElement = document.getElementById("dashboard-el-" + CONFIG.widgetId);
  if (rootElement) {
    ReactDOM.render(<DashboardWithNotices />, rootElement);
  }
}

// start Dashboard by mounting the root element
mountComponent();


